import { format } from 'date-fns';
import { enCA as dateEnCA, frCA as dateFrCA } from 'date-fns/locale';
import type { Locale } from '@/lib/dictionaries';

const dateLocales = {
  'en-CA': dateEnCA,
  'fr-CA': dateFrCA
};

export function formatDate(date: string | null, formatStr: string = 'MMM d, yyyy', locale: Locale = 'en-CA'): string {
  if (!date) return '';
  
  // Check for invalid/default dates (e.g., 0001-01-01)
  // Handle dates without timezone to avoid timezone shift issues
  const parsedDate = /^\d{4}-\d{2}-\d{2}$/.test(date) ? new Date(`${date}T00:00:00`) : new Date(date);
  if (isNaN(parsedDate.getTime()) || parsedDate.getFullYear() < 1900) {
    return '';
  }
  
  return format(parsedDate, formatStr, { locale: dateLocales[locale] });
}

export function formatCurrency(amount: number, locale: Locale = 'en-CA'): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount || 0);
}

export function formatPercentage(value: number | null | undefined, locale: Locale = 'en-CA'): string {
  if (value == null) return '';
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value / 100);
} 

export function formatString(value: string | null | undefined): string {
  if (!value) return '';
  return value;
}
